import { brandsColors } from "./styles"

export const getBrandColor = (brandName: string): string => {
  return (
    brandsColors[brandName as keyof typeof brandsColors] ||
    brandsColors["All Others"]
  )
}

export function getTotalEntityName(entity: string, data?: any) {
  return data?.[entity]?.entityName
}
